






















import {
  defineComponent,
  PropType,
  ref,
  computed
} from '@nuxtjs/composition-api';
import type { CustomizableAreaOption } from '@wemade-vsf/magento-api';
import { useCustomOptions } from '@wemade-vsf/catalog/lib/runtime/product/composables/useCustomOptions';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { SfHeading, SfTextarea } from '@storefront-ui/vue';

extend('required', {
  ...required,
  message: 'This field is required'
});

export default defineComponent({
  props: {
    option: {
      type: Object as PropType<CustomizableAreaOption>,
      required: true
    },
    productPrice: {
      type: Number,
      default: 0
    }
  },
  components: {
    SfHeading,
    SfTextarea,
    ValidationProvider
  },
  setup (props) {
    const {
      getTitleWithPrice,
      calculatePrice,
      optionEntered
    } = useCustomOptions();
    let title = computed(() => getTitleWithPrice({
      productPrice: props.productPrice,
      optionPrice: props.option.area?.price || 0,
      title: props.option.title || '',
      priceType: props.option.area?.price_type
    }))

    const textValue = ref('');
    const price = computed(() => {
      if (!textValue.value) return 0;
      return calculatePrice({
        productPrice: props.productPrice,
        optionPrice: props.option.area?.price || 0,
        priceType: props.option.area?.price_type
      })
    })

    const updateSelection = () => {
      optionEntered({
        uid: props.option.uid,
        value: textValue.value,
        price: price.value
      })
    }

    return {
      title,
      textValue,
      updateSelection
    }
  }
})
